module.exports = __webpack_public_path__ + "img/keeano.5ee167c4.png";